import React from 'react'
import { Intro } from './articles/Intro'
import { Header } from './components/Header'
import * as articles from './articles'
import { PUBLIC_URL } from './helpers'

export function App() {
  return (
    <div className="container">
      <style>{`@font-face {
    font-family: "CircularXX";
    src: local("CircularXX"),
      url("${PUBLIC_URL}/CircularXXWeb-Book.woff") format("woff");
  }`}</style>
      <Header />
      <Intro />
      {Object.entries(articles).map(([_, Component], index) => (
        <Component key={index} index={index} />
      ))}
    </div>
  )
}
